<div class="container">
  <h1 class="app-name clickable">TASTI-GRID</h1>
  <tgrid-location-selection-dropdown />

  <div class="user-menu" [matMenuTriggerFor]="userActions">
    <vulcan-icon size="36px" icon="user-circle"></vulcan-icon>
    <vulcan-icon size="24px" icon="caret-down"></vulcan-icon>
  </div>
</div>

<mat-menu #userActions="matMenu" overlapTrigger>
  <button mat-menu-item routerLink="/app/profile">Profile</button>
  @if (isUserManager()) {
    <button mat-menu-item [matMenuTriggerFor]="adminControlsMenu">
      Admin Controls
    </button>
  }
  <button mat-menu-item (click)="openFeedbackModal()">Provide Feedback</button>
  <button mat-menu-item (click)="requestApiKey()">Request API-Key</button>
  @if (isImpersonating()) {
    <button mat-menu-item (click)="unimpersonate()">
      Unimpersonate
    </button>
  }
  <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<mat-menu #adminControlsMenu="matMenu">
  <button mat-menu-item routerLink="/app/admin-controls/layer-management">
    Layer Management
  </button>
  <button mat-menu-item routerLink="/app/admin-controls/user-management">
    User Management
  </button>
  <button mat-menu-item routerLink="/app/admin-controls/user-access-management">
    User Access Management
  </button>
</mat-menu>
